import { render, staticRenderFns } from "./BatchEdit.vue?vue&type=template&id=36f55215"
import script from "./BatchEdit.vue?vue&type=script&lang=js"
export * from "./BatchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports